import {
    TActionType,
    TransactionType,
} from '../../../Utility/Tracking/DataSet/Transaction';
import { gameTracking } from '../../../Utility/Tracking/FBLegacyTracking';
import { FBTrackingEvent } from '../../../Utility/Tracking/FBTrackingEvent';
import { track, TrackMethod } from '../../../Utility/Tracking/Track';
import { trackTransaction } from '../../../Utility/Tracking/TrackingHelpers/Transaction';
import { IGameState } from '../../Game/IGameState';
import { setBoosterPlusFive } from '../../Player/PlayerInventoryHelper';
import CardStateHelper from '../CardStateHelper';
import { CardTask } from '../CardTasks';
import BaseBoosterBehavior from './BaseBoosterBehavior';

export default class PlusFiveBoosterBehavior extends BaseBoosterBehavior {
    public play(state: IGameState): IGameState {
        const targets: string[] = [];

        state = CardStateHelper.addNewCards(state, 5, targets);

        // Trigger plus three cards animation task.
        state = CardStateHelper.setStateTaskData(state, {
            task: CardTask.PLUS_FIVE,
            cards: targets,
        });

        return this.consumeItemOrCoins(state);
    }

    protected getPrice(state: IGameState): number {
        return state.levelState.boosterPrices.plusFive;
    }

    protected getInventoryItem(state: IGameState): number {
        return state.playerState.inventory.boosterPlusFive;
    }

    protected spendCoins(state: IGameState): IGameState {
        track('tLevelExtraCardsReceived', 5, TrackMethod.ADD);
        track('tLevelExtraCardsNumber', 1, TrackMethod.ADD);
        state = super.spendCoins(state);

        gameTracking(FBTrackingEvent.TapOnBuyFiveCards);

        track('mExtraCardsBought', 5, TrackMethod.ADD);

        return {
            ...state,
            // Increase the price (+50).
            levelState: {
                ...state.levelState,
                boosterPrices: {
                    ...state.levelState.boosterPrices,
                    plusFive: this.getPrice(state) + 50,
                },
            },
        };
    }

    protected spendInventoryItem(state: IGameState) {
        track('tLevelExtraCardsReceived', 5, TrackMethod.ADD);
        track('tLevelExtraCardsNumber', 1, TrackMethod.ADD);
        trackTransaction(state, TransactionType.AD, TActionType.BOOSTER_USE);

        return {
            ...state,
            playerState: setBoosterPlusFive(
                state.playerState,
                state.playerState.inventory.boosterPlusFive - 1
            ),
            // Increase the price (+50).
            levelState: {
                ...state.levelState,
                boosterPrices: {
                    ...state.levelState.boosterPrices,
                    plusFive: this.getPrice(state) + 50,
                },
            },
        };
    }
}
